import { gql } from '@apollo/client';

export const BROKERS_ON_OFFICE_QUERY = gql`
  query GetBrokersOnOffice($input: OfficeInput) {
    getOffice(input: $input) {
      id
      name
      brokers {
        list {
          name
          image {
            full
          }
          email
          cellphone
          title
          path
        }
      }
    }
  }
`;
